import { render } from "./RssFeedBrowserVx.vue?vue&type=template&id=3993f85a"
import script from "./RssFeedBrowserVx.vue?vue&type=script&lang=js"
export * from "./RssFeedBrowserVx.vue?vue&type=script&lang=js"

import "./RssFeedBrowserVx.vue?vue&type=style&index=0&id=3993f85a&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__